module.exports = __webpack_public_path__ + "static/media/blank-canvas.3ee35da9.png";